import { transactionPaymentHttpClient } from "../../../installations/axiosInterfaces";

const getPaymentPage = (companyId, clientId, chargePointId) => {
  return transactionPaymentHttpClient.get(`PaymentPage/${companyId}/${clientId}/${chargePointId}`);
};

const createPaymentToken = (data) => {
  return transactionPaymentHttpClient.post(`createPaymentToken`, data);
};

const getCreditCardsDetails = (companyId, clientId) => {
  return transactionPaymentHttpClient.get(`CreditCardsDetails/${companyId}/${clientId}`);
};

const deleteClientPaymentToken = (clientPaymentTokenId) => {
  return transactionPaymentHttpClient.delete(`DeleteClientPaymentToken/${clientPaymentTokenId}`);
};

const transactionPaymentService = {
  getPaymentPage,
  createPaymentToken,
  getCreditCardsDetails,
  deleteClientPaymentToken,
};

export default transactionPaymentService;
